import { SVGProps } from '../types';

const DinersClubIcon = (props: SVGProps) => (
  <svg
    width="46"
    height="32"
    viewBox="0 0 46 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      fill="white"
    />
    <path
      d="M4 0.5H42C43.933 0.5 45.5 2.067 45.5 4V28C45.5 29.933 43.933 31.5 42 31.5H4C2.067 31.5 0.5 29.933 0.5 28V4C0.5 2.067 2.067 0.5 4 0.5Z"
      stroke="#DEDBD4"
    />
    <path
      d="M24.5793 6.40116C29.9824 6.31711 34.3725 10.688 34.4572 16.0672V16.1512C34.2884 21.4465 29.9825 25.7332 24.5793 25.7332H21.1184C15.8841 25.649 11.6623 21.3624 11.6623 16.1512C11.4938 10.9402 15.5468 6.56936 20.6965 6.40116H24.5793ZM21.3713 8.0828C16.9815 8.083 13.351 11.6967 13.3508 16.0672C13.3508 20.4378 16.9813 24.0523 21.3713 24.0525C25.7614 24.0525 29.3918 20.4379 29.3918 16.0672C29.3915 11.6966 25.7613 8.0828 21.3713 8.0828ZM20.1047 21.4471C17.15 20.6905 15.3771 17.6642 16.1369 14.7224C16.6434 12.7894 18.1631 11.2767 20.1047 10.7722V21.4471ZM22.6379 10.7722C25.5926 11.5287 27.4502 14.4702 26.6906 17.4119C26.1841 19.4292 24.6641 20.9427 22.6379 21.4471V10.7722Z"
      fill="#0079BE"
    />
  </svg>
);

export { DinersClubIcon };
